import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => (
  <>
    
    <main style={mainStyle}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> August 5, 2025</p>
      <p>Your privacy is important. This policy explains what information we collect—or don’t collect—and how it's used.</p>

      <h2>1. Information We Do Not Collect</h2>
      <p>We do <strong>not</strong> collect any personal data such as names, email addresses, phone numbers, or ID numbers. There is no registration, login, or application process on CurrentJobs.co.ke.</p>

      <h2>2. Cookies & Third‑Party Services</h2>
      <p>We use third‑party services like **Ezoic** to deliver ads and monitor website performance. These providers may use cookies or similar technologies according to their own privacy policies.</p>
      <p>You can manage or disable cookies via your browser settings.</p>

      <h2>3. Aggregated Analytics</h2>
      <p>We may collect non‑personal aggregate information such as browser type, device, country, referrer URL, or general usage patterns to help us improve the site.</p>

      <h2>4. Links to Other Websites</h2>
      <p>We link to external job boards and resources. We are not responsible for their privacy practices. Please review the third‑party sites' policies before sharing any personal information.</p>

      <h2>5. Data Protection Compliance</h2>
      <p>We operate under the **Kenya Data Protection Act, 2019** and related regulations. Since we do not process any personal data, we have minimal compliance obligations. However, we maintain reasonable security and transparency regarding the limited data we do process (e.g. non-identifiable analytics).</p>
      <p>Under Kenyan law, individuals may exercise rights such as accessing any data, correction, or complaint through the relevant data controllers—but we do not store personal data.</p>

      <h2>6. Children’s Privacy</h2>
      <p>The site is not intended for children under 13 years old. We do not knowingly collect information from minors.</p>

      <h2>7. Policy Changes</h2>
      <p>We may update this policy. Updates will be posted here with a revised effective date.</p>

      <h2>Contact Us</h2>
      <p>For any privacy-related inquiries, contact us at <a href="mailto:info@currentjobs.co.ke">info@currentjobs.co.ke</a>.</p>
    </main>
  
  </>
);

const mainStyle = { padding: '2rem', maxWidth: '800px', margin: 'auto', lineHeight: 1.6 };

export default PrivacyPolicy;
